"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var React = _interopRequireWildcard(require("react"));
var _context = require("../../containers/GenplanContainer/context");
var _hooks = require("../../hooks");
var styles = _interopRequireWildcard(require("./Anchor.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Anchor = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isActive,
    center
  } = _ref;
  const {
    subscribeToTransform,
    genplanSize
  } = (0, _context.useGenplanContext)();
  const anchorPosition = (0, _hooks.useAnchorPosition)({
    subscribeToGenplanTransform: subscribeToTransform,
    center,
    genplanSize
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      left: `calc(${anchorPosition.left})`,
      top: `calc(${anchorPosition.top} - 0.2%)`
    },
    className: (0, _clsx.default)(styles['anchor'], isActive && styles['anchor-active']),
    ref: ref,
    "aria-label": "\u042F\u043A\u043E\u0440\u044C \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0433\u0435\u043D\u043F\u043B\u0430\u043D\u0430"
  });
});
exports.Anchor = Anchor;
Anchor.displayName = 'Anchor';